import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../../scripts/components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap/index"

export default class LoyaltyProgram extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const lines = qsa(".left .line-0", this.el)

    lines.forEach(line => {
      line.style.overflow = "hidden"
    })

    const borders = qsa(".border", this.el)
    const titles = qsa(".left .char-1", this.el)

    const items = qsa(".item .line-0", this.el)
    const images = qsa(".img-wrapper", this.el)
    const cta = qs(".cta-wrapper", this.el)

    gsap.from(cta, {
      y: "100",
      duration: 1.2,
      autoAlpha: 0,
      scrollTrigger: {
        trigger: cta,
        start: "top bottom",
      },
    })

    gsap.from(images, {
      y: "100%",
      duration: 1.2,
      stagger: 0.05,
      scrollTrigger: {
        trigger: images,
        start: "top bottom",
      },
    })

    titles.forEach(title => {
      gsap.from(title, {
        y: "100%",
        duration: 1.2,
        stagger: 0.05,
        scrollTrigger: {
          trigger: title,
          start: "top bottom",
        },
      })
    })

    borders.forEach(border => {
      gsap.from(border, {
        scaleX: 0,
        stagger: 0.07,
        duration: 1.2,
        scrollTrigger: {
          trigger: border,
          start: "top bottom",
        },
      })
    })

    items.forEach(item => {
      gsap.from(item, {
        y: "100%",
        duration: 1.2,
        stagger: 0.05,
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
        },
      })
    })

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
